import React from "react";
import { styled } from "../theme/stitches.config";

function NavbarLink({
  text,
  baseURLPannel,
  suffixURLPannel,
  variant,
  ...props
}) {
  return (
    <ButtonLink
      href={`${baseURLPannel}${suffixURLPannel}`}
      variant={variant}
      {...props}
    >
      {text}
    </ButtonLink>
  );
}

const ButtonLink = styled("a", {
  display: "flex",
  justifyContent: "center",
  color: "#fff",
  fontSize: "16px",
  height: "74px",
  margin: "auto",
  minWidth: "100px",
  textAlign: "center",
  // "border": "red 3px solid",

  "&:hover": {
    color: "#f7a11d",
  },

  "@md": {
    padding: "24px 15px 22px",
  },

  variants: {
    variant: {
      dropdownItem: {
        fontFamily: "UOLTextBold",
        fontSize: "13px",
        justifyContent: "left",
        padding: "4px 0",
        height: "auto",
      },
      drawer: {
        fontFamily: "UOLTextBold",
        fontSize: "13px",
        justifyContent: "left",
        padding: "4px 0",
        height: "auto",
      },
      live: {
        padding: "4px 0",
        height: "auto",
        "&::before": {
          content: "⬤",
          fontSize: "8px",
          marginRight: "3px",
          color: "red",
        },
      },
      liveDrawer: {
        fontFamily: "UOLTextBold",
        fontSize: "13px",
        justifyContent: "left",
        padding: "4px 0",
        height: "auto",
        "&::before": {
          content: "⬤",
          fontSize: "8px",
          marginRight: "3px",
          color: "red",
        },
        "&:hover": {
          color: "#f7a11d",
        },
      },
    },
  },
});

export default NavbarLink;
